import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

// 交易管理-条件查询商户交易订单
const tradeOrder = (data) => {
  return fetch({
    url: `${shop_url}/shop/mp/order`,
    data,
    method: 'post'
  })
}
const tradeDataOrder = (data) => {
  return fetch({
    url: `${shop_url}/shop/pms/order/refund`,
    data,
    method: 'post'
  })
}
// 查看已详情记录
const refundDetail = (refundOrderId) => {
  return fetch({
    url: `${shop_url}/shop/mp/mch/order/refund/${refundOrderId}`
  })
}
// 获取退款详情
const refundForm = (orderId) => {
  return fetch({
    url: `${shop_url}/shop/mp/mch/order/info/${orderId}`
  })
}

// 获取退款记录
const refundRecord = (orderId) => {
  return fetch({
    url: `${shop_url}/shop/mp/mch/order/refund/list/${orderId}`
  })
}
export {
  tradeOrder,
  tradeDataOrder,
  refundDetail,
  refundForm,
  refundRecord
}



// WEBPACK FOOTER //
// ./src/api/trade/index.js